/* FolderCreate Messages
 *
 * This contains all the text for FolderCreate component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  saveFolderSuccess: {
    id: 'app.containers.FolderCreate.saveFolderSuccess',
    defaultMessage: 'Folder has been successfully created.',
  },
  saveFolderFailure: {
    id: 'app.containers.FolderCreate.saveFolderFailure',
    defaultMessage: 'Error. The folder could not be created.',
  },
  title: {
    id: 'app.containers.FolderCreate.title',
    defaultMessage: 'Create folder',
  },
  currentFolder: {
    id: 'app.containers.FolderCreate.currentFolder',
    defaultMessage: 'Current folder',
  },
  rootFolder: {
    id: 'app.containers.FolderCreate.rootFolder',
    defaultMessage: 'Root folder',
  },
});
